<template>
  <div class="has-text-left">
    <div v-if="!continueButton">
      <h5 class="title">{{$t("please_enter_amount")}}</h5>

      <div class="field has-addons">
        <p class="control">
          <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
        </p>
        <p class="control">
          <input
            v-validate="'required|currency|min_value:' + (APM == 'mulixPayretailers' ? '50' : '1')"
            :class="{'input': true, 'is-danger': errors.has('amount') }"
            name="amount"
            type="text"
            :data-vv-as="translations.text.amount"
            :placeholder="translations.text.amount"
            v-model="amount"
          />
          <span
            v-show="errors.has('amount')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('amount') }}</span>
        </p>
        <!--p class="control">
          <a
            class="button is-success"
            @click="deposit"
          >
            <span class="icon is-small">
              <i
                class="fa fa-check"
                :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
              ></i>
            </span>
            <span>{{$t("deposit").tTitle()}}</span>
          </a>
        </p-->
      </div>

      <component
        v-if="APM"
        :is="methods[APM]"
        @request="sendMulixRequest"
      ></component>

      <!--p class="subtitle">{{$t("card_redirect")}}</p-->
    </div>
    <div v-else-if="payment.URL != ''">
      <div
        v-show="!frameLoaded"
        class="is-center"
      >Loading...</div>
      <iframe
        :src="payment.URL"
        frameborder="0"
        id="pay_embed"
        class="tile mulix-frame"
        @load="frameLoad"
      ></iframe>
    </div>
    <div v-else-if="payment.error">
      There was an error contacting the payment provider. Please try again.
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import config from '../../../config'
import depMethods from './mulix-methods'

export default {
  props: ['apm'],
  data() {
    return {
      amount: 0,
      continueButton: false,
      frameLoaded: false,
      payment: {
        error: false,
        URL: '',
        ID: '',
      },
      translations: {
        text: {
          amount: this.$t('amount'),
        },
      },
      currencySymbols: config.currencies,
      methods: depMethods,
      apmMap: {
        mulixVisa: 'VISA',
        mulixPayretailers: 'PAYRETAILERS',
      },
      checker: null,
    }
  },
  // watch: {},
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
    APM() {
      let method = 'mulixVisa'
      if (this.apm) {
        method = this.apm
        let parts = method.split('-')
        parts.forEach((v, i, a) => {
          if (i > 0) {
            a[i] = v.tCapitalizeFirstLetter()
          }
        })
        method = parts.join('')
      }

      return method
    },
  },
  mounted() {
    /*
    if (typeof this.User.info.country_code !== 'undefined' && this.User.info.country_code !== '') {
      this.country = this.User.info.country_code
    }
    */
    // console.log(this.methods)
  },
  beforeDestroy() {
    if (this.checker != null) {
      clearInterval(this.checker)
    }
  },
  methods: {
    deposit() {
      /*
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }

        let depositArgs = {
          userID: this.$store.state.user.info.ID,
          amount: String(this.amount),
          method: 'VISA',
          payment_data: {},
        }

        this.$bus.$emit('RequestDeposit', '/finance/deposit/mulix', depositArgs, response => {
          if (response.data.success) {
            this.paymentURL = data.redirectURL
          }
        })
      })
      */
    },
    sendMulixRequest(data = null) {
      this.payment_data = data
      this.continueToPayment()
    },
    continueToPayment() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }

        this.continueButton = true

        let depositArgs = {
          userID: this.$store.state.user.info.ID,
          amount: String(this.amount),
          method: this.APM ? this.apmMap[this.APM] : 'VISA',
          // env: 'production',
          payment_data: this.payment_data ? this.payment_data : {},
        }

        this.$bus.$emit(
          'RequestDeposit',
          '/finance/deposit/mulix',
          depositArgs,
          response => {
            this['logoLoader/set'](false)
            console.log(response)

            if (response.data.success) {
              this.payment.URL = response.data.redirectURL
              this.payment.ID = response.data.transactionID

              if (depositArgs.method == 'PAYRETAILERS') {
                // Check the status every few seconds to know when to redirect
                this.checker = setInterval(() => {
                  this.$bus.$emit('CheckDeposit', this.payment.ID)
                }, 5000)
              }
            } else {
              this.$toasted.error('There was an error contacting the payment provider. Please try again.')
              this.payment.error = true
            }
          },
          error => {
            console.log(error)
            this.payment.error = true
            if (error.response.data.meta) {
              let meta = error.response.data.meta
              if (meta[config.API.translationKeyName]) {
                this['errorModal/set']({ active: true, text: this.$t(meta[config.API.translationKeyName]).tTitle() })
              }
            }
          }
        )
      })
    },
    frameLoad() {
      this.frameLoaded = true
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../../assets/css/variables';

label {
  text-align: left;
}

.mulix-frame {
  height: 450px;

  max-width: 600px;
  width: 600px;

  @media only screen and (max-width: $tablet - 1px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Mulix.vue?6da01a90